import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {SettingLimit, SettingLimitListRequest, ListRequest} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {ColumnType} from "../list/list/ColumnType";
import {BonusSettingLimitService} from "../../services/BonusSettingLimitService";


interface State extends ListViewState<SettingLimitListRequest> {
    form? : SettingLimitListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class SettingLimitListView extends ListView<State, SettingLimitListRequest> implements FormListener<SettingLimitListRequest>{

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property: "currencyCode" , name : "Currency"},
        { property: "maxPaidPeriodUnit" , name : "Period Type"},
        { property: "maxPaidPeriodValue" , name : "Period Value"},
        { property: "maxPaidTotalAmount" , name : "Max Amount"},
        { property: "updatedBy", name : "Updated By", },
        { property: "updatedTimestamp", name : "Updated", type : ColumnType.DATE},
    ];

    actions = [
        { id : "delete", name : "delete", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CONFIRMATION},
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/bonus/setting-limit/" + item.id }

    ];

    service : BonusSettingLimitService;

    constructor(props : Props){
        super(props, "/bonus/setting-limits/list");
        this.state = {...this.state, validationMap : {}, form : {...this.state.listRequest} as any};
        this.service = getContainer().getBonusSettingLimitService();
    }
    onSubmit() : void | Promise<any> {
        if(this.state.form) {
            this.updateListState(this.state.form);
        }
    }
    onSubmitError() :  void {}

    formDidUpdate(formModel: ListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : SettingLimit, action : string) : Promise<any> | undefined {
        if(action === "delete") {
            return  this.service.remove(""+item.id);
        }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "List Bonus Global Limits";
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }

}

export default withRouter(SettingLimitListView);
